export default __webpack_public_path__ + "static/media/Biodiesel100.8d3b7632.svg";